<script lang="ts">
  interface Props {
    message: string;
    _class?: string;
  }

  let { message, _class = 'my-3' }: Props = $props();
</script>

<p class="text-center fst-italic {_class}">{message}</p>
